import { useEffect, useRef, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  Stack,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography
} from '@mui/material';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'


function MyVerticallyCenteredModal({ show, onHide, authToken, onCustomerAdd }) {
  const [searchFields, setSearchFields] = useState({
    title: '',
    forename: '',
    surname: '',
    email: '',
    phone_number: ''
  });
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const debounceRef = useRef();

  const fetchCustomerSearch = async () => {
    const isEmpty = Object.values(searchFields).every(v => !v);
    if (isEmpty) {
      setSearchResults([]);
      return;
    }

    try {
      setLoading(true);
      const res = await postRequest('private/leadsCustomerList', searchFields, authToken);
      setSearchResults(res?.data || []);
    } catch (err) {
      console.error('Error fetching search:', err);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchCustomerSearch, 400);
    return () => clearTimeout(debounceRef.current);
  }, [searchFields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateCustomer = async () => {
    try {
      setLoading(true);
      const res = await postRequest('private/createCustomer', searchFields, authToken);
      // Check if customer data exists regardless of status
      if (res?.data && res.data._id) {
        Swal.fire('Success', 'Customer created successfully!', 'success');
        const newCustomer = res.data;
        onCustomerAdd(newCustomer);
        onHide();
        setSearchFields({
          title: '',
          forename: '',
          surname: '',
          email: '',
          phone_number: ''
        });
      } else if ((res?.status === 'success' || res?.status === 200) && res?.data) {
        Swal.fire('Success', 'Customer created successfully!', 'success');
        const newCustomer = res.data;
        onCustomerAdd(newCustomer);
        onHide();
        setSearchFields({
          title: '',
          forename: '',
          surname: '',
          email: '',
          phone_number: ''
        });
      } else {
        Swal.fire('Error', res?.message || 'Failed to create customer', 'error');
      }
    } catch (err) {
      console.error('Error creating customer:', err);
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Customers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='m-0'>
          {['title', 'forename', 'surname', 'email', 'phone_number'].map((field, idx) => (
            <Col xs={field === 'email' || field === 'phone_number' ? 6 : 4} key={idx}>
              <Box sx={{ '& > :not(style)': { m: 1, width: '100%' } }}>
                <TextField
                  label={field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')}
                  name={field}
                  value={searchFields[field]}
                  onChange={handleChange}
                  variant="outlined"
                  type={field === 'email' ? 'email' : field === 'phone_number' ? 'tel' : 'text'}
                />
              </Box>
            </Col>
          ))}
        </Row>

        <Row className='mt-4'>
          <Col>
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Add</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4" className='text-center'>Loading...</td></tr>
                ) : searchResults.length > 0 ? (
                  searchResults.map((customer) => (
                    <tr key={customer._id}>
                      <td>{customer.title} {customer.forename} {customer.surname}</td>
                      <td>{customer.email}</td>
                      <td>{customer.phone_number}</td>
                      <td>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            onCustomerAdd(customer);
                            onHide();
                          }}
                        >
                          Add
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="4" className='text-center'>No customers found</td></tr>
                )}
              </tbody>
            </Table>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleCreateCustomer}
                disabled={loading || !searchFields.forename || !searchFields.surname || !searchFields.email}
                sx={{
                  backgroundColor: '#6f42c1',
                  '&:hover': { backgroundColor: '#5a34a0' },
                  textTransform: 'uppercase',
                  fontWeight: 'bold'
                }}
              >
                Add Customer
              </Button>
            </Box>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

const EditLssLastingPowersOfAttorneyForm = () => {
  console.log('edit-lss-lpa@12345678')
  const { lead_id } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const [groupCodes, setGroupCodes] = useState([]);
  const [productId, setProductId] = useState('');
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [customerError, setCustomerError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [overrideDate, setOverrideDate] = useState(dayjs());
  const [lenderPanels, setLenderPanels] = useState([]);
  const [partners, setPartners] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState({
    health_welfare: false,
    property_finance: false,
  });

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      group_code: '',
      acquisition: '',
      lender_panel_id: '',
      partner_id: '',
      documents: {
        health_welfare: false,
        property_finance: false,
      },
    },
  });

  const handleCustomerAdd = (customer) => {
    if (!selectedCustomers.some((c) => c._id === customer._id)) {
      setSelectedCustomers((prev) => [...prev, customer]);
      setCustomerError(false);
    }
  };

  const fetchGroupCodes = async () => {
    try {
      const res = await postRequest('private/getGroupCodeList', {}, authCtx.token);
      if (res?.status === 200 && Array.isArray(res.data)) {
        setGroupCodes(res.data);
      }
    } catch (err) {
      console.error('Error fetching group codes:', err);
    }
  };

  const fetchActiveLenderPanels = async () => {
    try {
      const response = await postRequest('private/getActiveLenderPanels', {}, authCtx.token);
      if (response?.status === 200 && response?.data) {
        setLenderPanels(response.data);
      }
    } catch (error) {
      console.error('Error fetching lender panels:', error);
    }
  };

  const fetchPartners = async () => {
    try {
      const payload = { page: 1, limit: 1000 };
      const response = await postRequest('private/partnerList', payload, authCtx.token);
      if (response?.status === 200 && response?.data?.docs) {
        setPartners(response.data.docs);
      }
    } catch (error) {
      console.error('Error fetching partners:', error);
    }
  };

  const fetchLeadDetails = async () => {
    try {
      const res = await postRequest(`private/get-single-lead/${lead_id}`, {}, authCtx.token);
      const lead = res?.data;

      console.log(lead, 'lss-lpa-lead----')

      if (lead) {
        reset({
          group_code: lead.group_code?._id ? String(lead.group_code._id) : '',
          acquisition: lead.acquisition || '',
          lender_panel_id: lead.lender_panel_id?._id ? String(lead.lender_panel_id._id) : '',
          partner_id: lead.partner_id?._id ? String(lead.partner_id._id) : '',
          documents: {
            health_welfare: lead.documents?.includes('Health & Welfare') || false,
            property_finance: lead.documents?.includes('Property & Finance') || false,
          },
        });

        // Set date if available
        if (lead.override_date) {
          setOverrideDate(dayjs(lead.override_date));
        }

        // Handle customers - ensure it's an array of objects
        if (Array.isArray(lead.customers) && lead.customers.length > 0) {
          // Check if customers are populated objects or just IDs
          const firstCustomer = lead.customers[0];
          if (typeof firstCustomer === 'object' && firstCustomer !== null && firstCustomer._id) {
            setSelectedCustomers(lead.customers);
          } else {
            // If customers are just IDs, initialize as empty array
            // User will need to add customers manually
            setSelectedCustomers([]);
          }
        } else {
          setSelectedCustomers([]);
        }

        setProductId(lead.product_id?._id || lead.product_id || '');
      }
    } catch (err) {
      console.error('Error fetching lead:', err);
      // Fallback to original API if new one doesn't exist
      try {
        const res = await postRequest(`private/get-single-lead/${lead_id}`, {}, authCtx.token);
        const lead = res?.data;
        if (lead) {
          reset({
            group_code: lead.group_code?._id ? String(lead.group_code._id) : '',
            acquisition: lead.acquisition || '',
            lender_panel_id: lead.lender_panel_id?._id ? String(lead.lender_panel_id._id) : '',
            partner_id: lead.partner_id?._id ? String(lead.partner_id._id) : '',
            documents: {
              health_welfare: lead.documents?.includes('Health & Welfare') || false,
              property_finance: lead.documents?.includes('Property & Finance') || false,
            },
          });
          if (lead.override_date) {
            setOverrideDate(dayjs(lead.override_date));
          }
          setSelectedCustomers(lead.customers || []);
          setProductId(lead.product_id?._id || '');
        }
      } catch (fallbackErr) {
        console.error('Error fetching lead (fallback):', fallbackErr);
      }
    }
  };

  useEffect(() => {
    fetchGroupCodes();
    fetchActiveLenderPanels();
    fetchPartners();
    fetchLeadDetails();
  }, [lead_id]);

  const onSubmit = async (formData) => {
    if (selectedCustomers.length === 0) {
      setCustomerError(true);
      return;
    }

    setLoading(true);

    // Convert documents object to array
    const documentsArray = [];
    if (formData.documents.health_welfare) documentsArray.push('Health & Welfare');
    if (formData.documents.property_finance) documentsArray.push('Property & Finance');

    const payload = {
      group_code: formData.group_code,
      acquisition: formData.acquisition,
      lender_panel_id: formData.lender_panel_id || null,
      partner_id: formData.partner_id || null,
      documents: documentsArray,
      product_id: productId,
      created_id: localStorage.getItem('id'),
      customer_ids: selectedCustomers.map((c) => c._id),
      override_date: overrideDate.toISOString(),
    };

    try {
      const res = await postRequest(`private/editLssLastingPowersOfAttorney/${lead_id}`, payload, authCtx.token);
      if (res?.status === 'success') {
        Swal.fire('Success', 'LSS Lasting Powers of Attorney lead updated successfully!', 'success');
        navigate(`/leads/view/lss-lasting-powers-of-attorney/${lead_id}`);
      } else {
        Swal.fire('Error', res?.message || 'Update failed', 'error');
      }
    } catch (err) {
      console.error('Edit error:', err);
      // Fallback to original edit API
      try {
        const fallbackRes = await postRequest(`private/lead-edit/${lead_id}`, payload, authCtx.token);
        if (fallbackRes?.status === 'success') {
          Swal.fire('Success', 'LSS Lasting Powers of Attorney lead updated successfully!', 'success');
          navigate(`/leads/view/lss-lasting-powers-of-attorney/${lead_id}`);
        } else {
          Swal.fire('Error', fallbackRes?.message || 'Update failed', 'error');
        }
      } catch (fallbackErr) {
        Swal.fire('Error', fallbackErr?.message || 'Something went wrong', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Leads', path: '/leads' },
          { label: 'Edit LSS Lasting Powers of Attorney', path: '' },
        ]}
      />
      <br />

      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Edit LSS Lasting Powers of Attorney #{lead_id}</h1>
      </div>

      <div className='page-top-formview mb-3'>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* Group Code & Acquisition */}
          <Row className="mb-3">
            <Col xs={12} md={6}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Group Code</h5>
              <Controller
                name="group_code"
                control={control}
                rules={{ required: 'Group Code is required' }}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.group_code}>
                    <InputLabel>Group Code</InputLabel>
                    <Select {...field} label="Group Code" value={field.value}>
                      {groupCodes.map((item) => (
                        <MenuItem key={item._id} value={String(item._id)}>
                          {`${item.name} (${item.code})`}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.group_code && (
                      <p style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>{errors.group_code.message}</p>
                    )}
                  </FormControl>
                )}
              />
            </Col>

            <Col xs={12} md={6}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Acquisition</h5>
              <Controller
                name="acquisition"
                control={control}
                rules={{ required: 'Acquisition is required' }}
                render={({ field }) => (
                  <FormControl fullWidth error={!!errors.acquisition}>
                    <InputLabel>Acquisition</InputLabel>
                    <Select {...field} label="Acquisition" value={field.value}>
                      <MenuItem value="Inbound">Inbound</MenuItem>
                      <MenuItem value="Cold-Acquistion">Cold-Acquistion</MenuItem>
                    </Select>
                    {errors.acquisition && (
                      <p style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>{errors.acquisition.message}</p>
                    )}
                  </FormControl>
                )}
              />
            </Col>
          </Row>

          {/* Documents & Override Date */}
          <Row className="mb-3">
            <Col xs={12} md={6}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Documents</h5>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Controller
                  name="documents.health_welfare"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          sx={{
                            '&.Mui-checked': { color: '#1976d2' },
                          }}
                        />
                      }
                      label="Health & Welfare"
                    />
                  )}
                />
                <Controller
                  name="documents.property_finance"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          sx={{
                            '&.Mui-checked': { color: '#1976d2' },
                          }}
                        />
                      }
                      label="Property & Finance"
                    />
                  )}
                />
              </Box>
            </Col>

            <Col xs={12} md={6}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Override Date (Optional)</h5>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Override Date"
                  value={overrideDate}
                  onChange={(newValue) => setOverrideDate(newValue)}
                  sx={{ width: '100%' }}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </Col>
          </Row>

          {/* Lender Panel & Partner */}
          <Row className="mb-3">
            <Col xs={12} md={6}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Lender Panel</h5>
              <Controller
                name="lender_panel_id"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth>
                    <Select
                      {...field}
                      displayEmpty
                      value={field.value}
                      sx={{ backgroundColor: 'white' }}
                    >
                      <MenuItem value="">
                        <em>Select Lender Panel (Optional)</em>
                      </MenuItem>
                      {lenderPanels.map((panel) => (
                        <MenuItem key={panel._id} value={String(panel._id)}>
                          {panel.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Col>

            <Col xs={12} md={6}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Partner</h5>
              <Controller
                name="partner_id"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth>
                    <Select
                      {...field}
                      displayEmpty
                      value={field.value}
                      sx={{ backgroundColor: 'white' }}
                    >
                      <MenuItem value="">
                        <em>Select Partner (Optional)</em>
                      </MenuItem>
                      {partners.map((partner) => (
                        <MenuItem key={partner._id} value={String(partner._id)}>
                          {partner.name || 'Unknown'}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Col>
          </Row>

          {/* Customers */}
          <Row className="mb-3">
            <Col xs={12}>
              <h5 className="mb-3" style={{ fontWeight: 600, color: '#2c3e50' }}>Customers</h5>
              {customerError && (
                <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                  Please select at least one customer.
                </Alert>
              )}
              {selectedCustomers.length > 0 && (
                selectedCustomers.map((customer) => (
                  <Box
                    key={customer._id}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      p: 2,
                      mb: 2,
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      backgroundColor: 'white'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {customer.title} {customer.forename} {customer.surname}
                      </Typography>
                      {customer.email && (
                        <Typography variant="body2" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          📧 {customer.email}
                        </Typography>
                      )}
                      {customer.phone_number && (
                        <Typography variant="body2" sx={{ color: '#666', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          📞 {customer.phone_number}
                        </Typography>
                      )}
                    </Box>
                    <Button
                      size="small"
                      onClick={() =>
                        setSelectedCustomers((prev) =>
                          prev.filter((c) => c._id !== customer._id)
                        )
                      }
                      sx={{
                        minWidth: 'auto',
                        color: '#d32f2f',
                        '&:hover': {
                          backgroundColor: '#ffebee'
                        }
                      }}
                    >
                      ✕
                    </Button>
                  </Box>
                ))
              )}
              {selectedCustomers.length === 0 && (
                <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, mb: 2 }}>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    No customers added yet. Click "Add Customer" to add customers.
                  </Typography>
                </Box>
              )}
              <Button
                variant="text"
                startIcon={<PersonAddOutlinedIcon />}
                onClick={() => setModalShow(true)}
                sx={{ color: '#6f42c1', mt: 1 }}
              >
                Add Customer
              </Button>
            </Col>
          </Row>

          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            authToken={authCtx.token}
            onCustomerAdd={handleCustomerAdd}
          />

          {/* Submit Button */}
          <Row className="mt-4">
            <Col xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2 }}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={loading}
                  sx={{
                    backgroundColor: '#6f42c1',
                    '&:hover': { backgroundColor: '#5a34a0' },
                    textTransform: 'capitalize',
                    padding: '10px 30px',
                    fontSize: '1rem',
                    fontWeight: 500
                  }}
                >
                  {loading ? 'Updating...' : 'Update'}
                </Button>
              </Box>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};


export default EditLssLastingPowersOfAttorneyForm;